import { Component, Input } from "@angular/core";
import { Person } from "../../models/persons/person";
import { ClientService } from "../../services/persons/client.service";
import { ModalReference, ModalService, ModalSize, } from "@developer-partners/ngx-modal-dialog";
import { TableViewModel } from "../../models/table-view-model";
import { ColumnType } from "../../components/sorting-filtering/query-view-model";
import { TableColumn } from "../../components/table/table.component";
import { Case } from "../../models/cases/case";
import { AuthService } from "../../services/auth.service";
import { CreateClientComponent } from "./create-client.component";
import { PermissionAction, PermissionType } from "../../models/persons/users/permission";

@Component({
    templateUrl: './client-lookup.component.html',
})

export class ClientLookupComponent {
    public clients: Person[] = [];
    public case: Case = {};
    public isLoading: boolean = true;
    public canAddClients = false;
    public table: TableViewModel<Person> = {
        columns: this.getColumns(),
        query: {
            sort: {},
            filter: [] 
        },
        freeTextSearch: {
            searchQuery: [
                { field: 'firstName', operator: 'Ct' },
                { field: 'lastName', operator: 'Ct' },
                { field: 'primaryEmail.text', operator: 'Ct' },
                { field: 'city', operator: 'Ct' }
            ]
        }
    };

    constructor(
        private readonly _clientService: ClientService,
        private readonly _modalReference: ModalReference<Person>,
        private readonly _modalService: ModalService,
        private readonly _authService: AuthService
    ) {
    }

    public async ngOnInit(): Promise<void> {
        this.canAddClients = await this._authService.hasAnyPermisison(
            PermissionAction.CanCreate,
            PermissionType.Clients
        );
        await this.getClients();
    }

    public async getClients(): Promise<void> {
        try {
            this.table.isLoading = true;
            this.table.items = await this._clientService.getAll(this.table.items?.pageInfo || {}, this.table.query);
        } finally {
            this.table.isLoading = false;
        }
    }

    private getColumns(): TableColumn<Person>[] {
        return [
            {
                field: 'firstName',
                caption: 'First Name',
                type: ColumnType.text
            },
            {
                field: 'lastName',
                caption: 'Last Name',
                type: ColumnType.text
            },
            {
                field: 'primaryEmail.text',
                caption: 'Primary Email',
                type: ColumnType.text
            },
            {
                field: 'primaryPhone.text',
                caption: 'Phone Number',
                type: ColumnType.text
            },
            {
                field: 'gender',
                caption: 'Gender',
                type: ColumnType.other,
                options: [
                    {
                        id: '1',
                        value: 'Unspecified'
                    },
                    {
                        id: '2',
                        value: 'Male'
                    },
                    {
                        id: '3',
                        value: 'Female'
                    }
                ]
            },
            {
                field: 'addressLine1',
                caption: 'Address Line 1',
                type: ColumnType.text
            },
            {
                field: 'addressLine1',
                caption: 'Address Line 2',
                type: ColumnType.text
            },
            {
                field: 'city',
                caption: 'City',
                type: ColumnType.text
            },
            {
                field: 'state.name',
                caption: 'State',
                type: ColumnType.other
            },
            {
                field: 'postalCode',
                caption: 'Postal Code',
                type: ColumnType.text
            }
        ];
    }

    public selectClient(client: Person): void {
        this._modalReference.closeSuccess(client);
    }

    public createClient(): void {
        this._modalService.show<Person>(CreateClientComponent, {
            title: 'Create Client',
            size: ModalSize.large
        }).result().subscribe(async (newClient) => {
            if (newClient) {
                await this.getClients();
            }
        });
    }
}